import CardCoupon from './card-coupon';
import GiftCard from './gift-card';

export default {
  CardCoupon,
  GiftCard,
};
